// Kanıt belgesi yükleme — allowEvidence=true olan NON-file sorular için (metin/sayı/…).
// Cevap kutusunun altında görünür; cevap değerine dokunmaz (opsiyonel destekleyici belge).
// Ortak yükleme mantığı AttachmentUploader'da (syncValue verilmez).
// Not: type:"file" sorularda gösterilmez — orada dosya zaten cevabın kendisi (FileRenderer).

import type { QuestionSnapshot } from "@mahir/shared";
import { AttachmentUploader } from "./AttachmentUploader";

export function EvidenceUpload({ question }: { question: QuestionSnapshot }): JSX.Element {
  return (
    <div className="mt-3">
      <div
        style={{
          color: "var(--color-text-2)",
          fontSize: "0.8rem",
          fontWeight: 600,
          marginBottom: 6,
        }}
      >
        📎 Kanıt belgesi <span style={{ fontWeight: 400 }}>(opsiyonel)</span>
      </div>
      <AttachmentUploader question={question} />
    </div>
  );
}
